// extracted by mini-css-extract-plugin
module.exports = {"productList":"ProductListTemp_productList__Kt7mP"};